var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "m-0 backgroundDiv" }, [
    _c(
      "div",
      { staticClass: "contentDiv" },
      [
        _c(
          "van-row",
          { staticClass: "rowsDiv" },
          [
            _c(
              "van-col",
              { attrs: { span: "3" } },
              [
                _c("van-icon", {
                  attrs: { name: "arrow-left", size: "30", color: "#FFDA3E" },
                  on: { click: _vm.rtList },
                }),
              ],
              1
            ),
            _c("van-col", { attrs: { span: "16" } }),
            _c(
              "van-col",
              { attrs: { span: "3" } },
              [
                _vm.visitData.createBy == _vm.loginUser.userId
                  ? _c("van-icon", {
                      attrs: { size: "30", color: "#FFDA3E", name: "edit" },
                      on: { click: _vm.onEditClick },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rowsDiv" },
          [
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("记录人")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.createByName)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("所属部门")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.createByDeptName)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("记录时间")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm
                          .moment(_vm.visitData.createTime)
                          .format("YYYY-MM-DD HH:mm")
                      )
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rowsDiv" },
          [
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("所属客户")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.customerCompanyName)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("客户地址")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.customerCompanyPlace)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("拜访日期")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.visitTime)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("拜访方式")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.visitTypeName)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("拜访人")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.customerUserName)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("拜访记录")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.visitGoal)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-col", { attrs: { span: "4" } }, [
                  _c("div", { staticClass: "row-name" }, [_vm._v("联系电话")]),
                ]),
                _c("van-col", { attrs: { span: "16" } }, [
                  _c("div", { staticClass: "row-value" }, [
                    _vm._v(_vm._s(_vm.visitData.customerUserPhone)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "van-row",
              {
                staticClass: "row-info",
                attrs: { type: "flex", justify: "space-around" },
              },
              [
                _c("van-field", {
                  staticClass: "noAfterBorder fileValueBox",
                  attrs: {
                    "input-align": "right",
                    name: "fj",
                    label: "附件",
                    placeholder: "请上传文件",
                  },
                  domProps: { value: _vm.visitData.fileList },
                  scopedSlots: _vm._u([
                    {
                      key: "input",
                      fn: function () {
                        return [
                          _c("uploadFiles", {
                            attrs: {
                              disabled: true,
                              uploaderBtnShow: false,
                              moduleType: "visit",
                              files: _vm.visitData.fileList,
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }